<template>
  <div>
    <span
      class="promotion"
      @click="saveUserCollection(true)"
      v-if="!isOrNoCollection(scope.row)"
    >
      <i class="el-icon-star-off" />
    </span>
    <span
      class="promotion star-on"
      @click="saveUserCollection(false)"
      v-else
    >
      <i class="el-icon-star-on" />
    </span>
  </div>
</template>

<script>
import api from '../../api';
import { isOrNoCollection } from '@/utils/mUtils';
export default {
  name: 'ProductOperate',
  props: {
    scope: {
      type: Object,
      default: () => {}
    }
  },
  components: {},
  data () {
    return {

    };
  },
  methods: {
    isOrNoCollection,
    saveUserCollection (operate) {
      this.scope.row.isCollection = operate;
      api.saveUserCollection(this.scope.row).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          // 跳转到已添加产品
          // this.added();
          if (operate) {
            this.$notify.success(this.$t('addConfigModule.collectionOfProductsSucceeded'));
          } else {
            this.$notify.success(this.$t('addConfigModule.cancelFavoriteProductsSuccessfully'));
          }
        } else {
          this.$notify.error(json.err);
        }
      }).catch(() => {
        this.$notify.error(this.$t('addConfigModule.networkAnomaly'));
      });
    }
  }
};
</script>

<style scoped>
  .promotion{
    font-size: 20px;
    color:#37BADE;
    cursor: pointer;
  }

  .star-on{
    transform: scale(1.3);
  }
</style>
